<div class="AcknowledgementContainer">
    <p-button appPreventDoubleClick *ngIf="isaddAcknowledgementBtnEnabled"
    pTooltip="Add Acknowledgement" tooltipPosition="bottom"
      id="addhardcopyAcknowledgementButton"
      class="add-acknowledgement-button"
      icon="fa fa-plus"
      iconPos="left"
      (debounceClick)="addAcknowledgement()"
    ></p-button>
  
          <app-panel-list *ngIf="!showLoader" [panelList]="documentAcknowledgementData"
          [noResultFound] = "!ispanelListDataAvailable">
              <ng-template #templateRef let-data="dataVar">
                  <div panel-content>
                      <div class="grid">
                              <div class="fields-row">
                          <div class="col1">
                              <app-label labelText="{{ 'Assigned User'}}"></app-label>
                              <app-read-only readonlyText="{{data?.assignedInternalUser}}"></app-read-only>
                          </div>
                          <div class="col2">
                              <app-label labelText="{{ 'Type'}}"></app-label>
                              <div class="text-container">
                                  <app-read-only readonlyText="{{ data?.type }}" ></app-read-only>
                              </div>
                          </div>
                          <div class="col3">
                            <app-label labelText="{{ 'Status'}}"></app-label>
                            <div class="grid pt-1">
                                <div class="col max-w-0 ml-1">
                                  <em class="pi pi-circle-fill pt-1"
                                  [ngClass]="{ 'scheduled' : data?.status == 'Scheduled', 'pending' : 
                                  data?.status == 'Pending', 'acknowledged':data?.status == 'Acknowledged', 'sent':data?.status == 'Sent',
                                   'notAcknowledged' : data?.status == 'Not Acknowledged'}"></em>
                                </div>
                                <div class="col ml-2">
                                    <app-read-only readonlyText="{{data?.status}}"></app-read-only>
                                </div>
                            </div>
                        </div>
                          <div class="col4">
                              <app-label labelText="{{ 'Due Date'}}"></app-label>
                              <app-read-only readonlyText="{{data?.dueDate | date: 'dd-MMM-yyyy'}}"></app-read-only>
                          </div>
                          <div class="col5">
                            <app-label labelText="{{ 'Acknowledgement Date' }}"></app-label>
                            <app-read-only readonlyText="{{data?.acknowledgementDate | date: 'dd-MMM-yyyy'}}"></app-read-only>
                        </div>
                        <div class="col6" >
                          <button appPreventDoubleClick *ngIf="data?.status === 'Pending' && data?.type === 'Internal' && data?.isAssignedUserForAcknowledgement"
                           pButton pRipple type="button" id="confirmAcknowledgementButton" pTooltip="Acknowledge" tooltipPosition="bottom" 
                            icon="fa fa-check"class="li blue-color p-button-rounded p-button-text" (debounceClick)="openAcknowledgementConfirmationModal(data?.acknowledgementId)">
                              </button>
                        </div>
                        <div class="col7" >
                          <button appPreventDoubleClick *ngIf="(data?.status === 'Pending' || data?.status === 'Scheduled') 
                          && (data?.acknowledgementAuthorizationFlags.isLoggedInUserAssignedAdmin || data?.acknowledgementAuthorizationFlags.isLoggedInUserAssignedAdminGroup)"
                            pButton pRipple type="button" id="deleteAcknowledgementButton" pTooltip="Delete Acknowledgement" tooltipPosition="bottom" 
                            icon="fa fa-trash"class="li blue-color p-button-rounded p-button-text" (debounceClick)="deleteAcknowledgement(data?.acknowledgementId)">
                          </button>
                        </div>
                      </div>
                          <div>
                          </div>
                      </div>
                  </div>
              </ng-template>
  
          </app-panel-list>
      
  


  <div *ngIf="isDeleteAcknowledgementModal">
    <app-delete-acknowledgement
      [isDeleteAcknowledgementModal]="isDeleteAcknowledgementModal"
      [acknowledgementId]="acknowledgeIdToDelete"
      (isDeleteAcknowledgementModalVisible) = "closeDeleteAcknowledgementModal($event)"
    >
    </app-delete-acknowledgement>
  </div>

    <div>
      <app-acknowledgement-slider
        [isAcknowledgementSliderOpen]="isAcknowledgementSliderOpen"
        (isAcknowledgementSliderActive)="closeAcknowledgementSlider($event)"
        [documentNumber]="documentNumber"
        [documentVersion]="documentVersion"
        [documentPhaseNumber] ="documentPhaseNumber"
        [documentEffectiveDate]="documentEffectiveDate"
      >
      </app-acknowledgement-slider>
    </div>

    <p-dialog
    [(visible)]="showAcknowledgementConfirmationModal"
    [style]="{ width: '35vw' }"
    (onHide)="closeConfirmationModal()"
    [modal]="true"
  >
    <ng-template pTemplate="header">
      <span class="font-semibold text-xl">Confirmation</span>
    </ng-template>
    <div>
      <span>
      <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
      {{acknowledgementConfirmationText}}    </span>
    </div>
    <ng-template pTemplate="footer">
      <p-button
      appPreventDoubleClick
        label="No"
        type="submit"
        icon="pi pi-times"
        id="acknowlegementConfirmationNoButton"
        styleClass="p-button-outlined"
        class="align-right"
        (debounceClick)="closeConfirmationModal()"
      >
      </p-button>
      <p-button
      appPreventDoubleClick
        label="Yes"
        icon="pi pi-check"
        type="submit"
        id="acknowlegementConfirmationYesButton"
        class="align-right"
        (debounceClick)="updateAcknowledgementData()"
      >
      </p-button>
      
    </ng-template>
  </p-dialog>

  </div>
